import React from "react";
import { Box } from "@mui/material";
import logo from "../../Assets/Images/logo.png";
export const NotFound = () => {
  return (
    <>
      <Box className="forget-passwordForm">
        <Box className="form-contianer">
          {/* <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box> */}

          <Box className="input forget-password-input">
            <Box
              sx={{
                textAlign: "center",
                fontSize: "70px",
              }}
            >
              Oops!
            </Box>
            <Box
              sx={{
                textAlign: "center",
                fontSize: "40px",
              }}
            >
              404 - Page Not Found
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
